const $ = require('jquery');

$(function () {


	$(".block-tabs").each(function () {

		var $activeClassIdentifier = "active";
		var $blockTabs = $(this);
		var $tabElements = $(this).find(".block-tab");
		var $header = $(this).find(".block-tabs-header");

		// Create nav container
		var $navContainer = $("<div class='block-tabs-nav-container'>");
		$header.after($navContainer);

		// Init all tabElements
		$tabElements.each(function (index) {
			var $tabElement = $(this);

			// Create nav element
			var $navElement = $("<div class='block-tabs-nav-element'>");
			$navElement.text($tabElement.data("title"));
			$navContainer.append($navElement);

			$navElement.on("click", function (event) {
				event.preventDefault();
				// Hide/show
				$tabElements.hide();
				$tabElement.show();
				$blockTabs.find(".block-tabs-nav-element").removeClass($activeClassIdentifier);
				$navElement.addClass($activeClassIdentifier);
			});

			// Check if an anchor is given
			var hashComponent = window.location.hash;
			if (hashComponent) {

				// Remove get parameters
				var hash = hashComponent.split('?')[0];
				
				// Check if the anchor tag is inside the tab
				var $anchorTarget = $tabElement.find(hash);
				if ($anchorTarget.length) {
					$navElement.addClass($activeClassIdentifier);
				} else {
					$tabElement.hide();
				}

			} else {

					// Hide, except first
				if (index) {
					$tabElement.hide();
				} else {
					// Show first nav as active
					$navElement.addClass($activeClassIdentifier);
				}
			}



		});

	});

});

